<script>
    import MediaQuery from 'svelte-media-query';
    export let buttonText = "Shop"
</script>

<MediaQuery query="(max-width: 480px)" let:matches>
    {#if matches}        
        <img class='tw-mt-2' loading='eager' width={25} height={16} src="https://cdn.shopify.com/s/files/1/0114/4120/9408/t/177/assets/Hamburger-menu.svg?v=1172915541407629834" alt="menu" />     
    {:else}
        <span class='tw-text-sm tw-font-medium tw-uppercase tw-cursor-pointer hover:tw-underline tw-tracking-widest tw-leading-tight tw-font-sans'>{buttonText}</span>
    {/if}
</MediaQuery>